<template>
    <!--srcviewscompanylistcompanyvuehtmlStart-->
 <div >
    <div id="defaultId1" class="uedbd2" style="display: flex">
     
        <div :class="token && this.Saved == '' && !this.Compare ? '' : 'vague'" style="height: 100%;">
            <div class="left_menu">

                <el-collapse v-model="openMenu" v-loading="Leftloadig" @change="zhankai()" ref="collapseItem">
                    <el-collapse-item title="Date" name="1">
                        <template slot="title">
                            <div class="collapsetitel">Date</div>
                        </template>
                        <div class="cas_panel cas_loc">
                            <el-date-picker    :append-to-body="true" v-model="datePicker" @change="menuCheck()"
                                style="width: fit-content;max-width: 350px;" type="daterange" range-separator=""
                                start-placeholder="Starting Month" value-format="yyyy-MM-dd HH:mm:ss"
                                :default-time="['00:00:00', '23:59:59']" end-placeholder="End Month"></el-date-picker>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item title="Company Name" name="2">
                        <template slot="title">
                            <div class="collapsetitel">Company Name</div>
                            <!-- <i class="header-icon el-icon-lock hedr-icon-ydong" v-if="!powerResult?.list[1]?.power"></i> -->
                        </template>
                        <div class="cas_panel cas_loc">
                            <el-input type="text" v-model="cascInptComapny" clearable :placeholder="$t('Home.selectCountry')"
                               @change="menuCheck()" />

                        </div>
                    </el-collapse-item>

                    <el-collapse-item title="Industry" name="3">
                        <template slot="title">
                            <div class="collapsetitel">{{ $t('ContentTabs.Industry') }}</div>
                        </template>
                        <div class="cas_panel cas_loc">
                            <el-select style="width: 100%;"  clearable v-model="cascInptIndustry" filterable
                                :popper-append-to-body="false" popper-class="new-search-select"
                                placeholder="Select Legal Risk"
                                  @change="menuCheck()">
                                <el-option v-for="(item, index) in industryList" :key="index" :label="item.groupNameEn"
                                    :value="item.groupNameEn">
                                    <div class="flex-between-center">
                                        <el-tooltip effect="light" :visible-arrow="false"
                                            :disabled="item?.groupNameEn < 25" :content="item.groupNameEn"
                                            placement="right">
                                            <span class="select-name">{{ item.groupNameEn }}</span>
                                        </el-tooltip>
                                    </div>
                                </el-option>
                            </el-select>

                        </div>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('Snapshot.CompanyType')" name="4">
                        <template slot="title">
                            <div class="collapsetitel">{{ $t('Snapshot.CompanyType') }}</div>
                        </template>
                        <div class="coll_child">
                            <el-checkbox-group v-model="companyTypeCheckList" @change="menuCheck('companyType')">
                                <el-checkbox v-for="(child, i) in companyTypeList" :key="i" :label="child.groupNameEn">
                                    <el-tooltip :disabled="isShowTooltip" class="line_1 coll_child_name" effect="dark"
                                        :content="child.groupNameEn" placement="right">
                                        <div @mouseover="onMouseOver(child.groupNameEn, i)"
                                            class="line_1 coll_child_name">
                                            <span style="font-style: none" ref="str">{{
                                                child.groupNameEn
                                                }}</span>
                                        </div>
                                    </el-tooltip>
                                    <el-tooltip class="coll_child_num line_1" effect="dark"
                                        :content="child.count | FilterNum" placement="right">
                                        <!-- <span class="coll_child_num line_1">{{
                      child.count | FilterNum
                    }}</span> -->
                                    </el-tooltip>
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </el-collapse-item>
                    <!-- <el-collapse-item title="Company Size" name="5">
            <template slot="title">
              <div class="collapsetitel">{{ $t('IndustryStatistics.CompanySize') }}</div>
            </template>
            <div class="coll_child">
              <el-checkbox-group v-model="companySizeCheckList" @change="menuCheck('companySize')">
                <el-checkbox v-for="(child, i) in companySizeList" :key="i" :label="child.name">
                  <div class="line_1 coll_child_name">{{ child.name }}</div>
          
         
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-collapse-item> -->
                    <el-collapse-item title="Company Status" name="6">
                        <template slot="title">
                            <div class="collapsetitel">{{ $t('IndustryStatistics.CompanyStatus') }}</div>
                        </template>
                        <div class="coll_child">
                            <el-checkbox-group v-model="companyStatusCheckList" @change="menuCheck('companyStatus')">
                                <el-checkbox v-for="(child, i) in companyStatusList" :key="i"
                                    :label="child.groupNameEn">
                                    <div class="line_1 coll_child_name">{{ child.groupNameEn }}</div>

                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </el-collapse-item>
                    <!-- <el-collapse-item title="Listed Company" name="7">
            <template slot="title">
              <div class="collapsetitel">{{ $t('ListofResults.ListedCompany') }}</div>
            </template>
            <div class="coll_child">
              <el-checkbox-group v-model="listedCompanyCheckList" @change="menuCheck('listedCompany')">
                <el-checkbox v-for="(child, i) in listedCompanyList" :key="i" :label="child.name">
                  <div class="line_1 coll_child_name">{{ child.name }}</div>
         
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-collapse-item> -->
                    <!-- <el-collapse-item title="Years in Business" name="8">
            <template slot="title">
              <div class="collapsetitel">{{ $t('ListofResults.YearsinBusiness') }}</div>
            </template>
            <div class="coll_child">
              <el-checkbox-group v-model="timePeriodCheckList" @change="menuCheck('timePeriod')">
                <el-checkbox v-for="(child, i) in timePeriodList" :key="i" :label="child.name">
                  <div class="line_1 coll_child_name">{{ child.name }}</div>
         
        
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-collapse-item> -->
                </el-collapse>

            </div>
        </div>


    </div>
    </div>

</template>
<script>

import { mixins1 } from "@/mixins/index";


import {
    getUserCompanyActionFilter,
} from "@/api/companyApi";
export default {

    mixins: [mixins1],
    components: {

    },
    name: "",
    props: {},

    updated() {


    },
    beforeDestroy() {

    },
    created() {


    },
    mounted() {
        this.getConditions();
    },
    computed: {

    },

    data() {
        return {
            datePicker: [],
            isComapanyNameEn: true,
            compareList: [],
            compareListParent: [],
            compareListChildreant: [],
            Remove: false,
            isFadedIn: true,
            loading: true,
            isOpenSlct: false,
            Clearallflase: false,
            showReportIndex: false,
            Compare: false,
            Export: false,
            Download: false,
            Update: false,
            Saved: '',
            Sort: [],
            labelCode: [],
            ReportError: false,
            CompanyName: "",
            powerToReportErrorStatus: false,
            retchildren: false,
            // columns


            token: localStorage.getItem("token"),
            optionsProps: {
                label: "name", //名称展示
                value: "value", //值展示
                expandTrigger: "click", //次级菜单的展开方式
            },
            parentTable: [],
            expands: [],
            cascInptComapny: "",
            showInptCountry: true,
            cascInptIndustry: "",
            showInptIndustry: true,
            childTable: [],



            checkedCompanyList: [],
            companyList: [],
            companyTblList: [],
            branchflag: "",
            openMenu: ['1','2', '3', '4', '5', '6', '7', '8'],
            // openMenu: [],
            // geographicalLocation:[],
            countryPreList: [],
            countryList: [],
            countryCheckList: [],
            countryTag: [],
            countryCheck: "",

            industryPreList: [],
            industryList: [],
            industryCheckList: [],
            industryTag: [],
            industryCheck: "",

            companyTypeList: [],
            companyTypeList1: [],
            companyTypeCheckList: [],
            companyTypeTag: [],
            companyTypeCheck: "",

            companySizeList: [],
            companySizeCheckList: [],
            companySizeTag: [],
            companySizeCheck: "",

            companyStatusList: [],
            companyStatusCheckList: [],
            companyStatusTag: [],
            companyStatusCheck: "",

            listedCompanyList: [],
            listedCompanyCheckList: [],
            listedCompanyTag: [],
            listedCompanyCheck: "",

            timePeriodList: [],
            timePeriodCheckList: [],
            timeTag: [],
            timePeriodCheck: "",
            province: [],
            city: [],
            keywords: "",
            cascaderKey: 0,
            Leftloadig: false,
            searchName: "",
            isShowTooltip: false,
            checkList: [],

            // srcviewscompanylistcompanyvueDataEnd
        };
    },

    methods: {
        onChangeParams(value, name) {

        },
        inptCompanySearch() {

        },


      



        //
        setToolsfalse() {
       
            this.$store.dispatch("app/setTools", {

                name: "select",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {

                name: "edit",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "sort",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "collect",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "saved",
                key: "isActive",
                value: false,
            });

            this.$store.dispatch("app/setTools", {
                name: "compare",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "export",
                key: "isActive",
                value: false,
            });

            this.$store.dispatch("app/setTools", {
                name: "update",
                key: "isActive",
                value: false,
            });

            this.$store.dispatch("app/setTools", {
                name: "download",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "reportError",
                key: "isActive",
                value: false,
            });
        },



        setThemeColor() {
            this.$store.dispatch("app/setThemColor", "#1290C9");
            this.$store.dispatch("app/setSearchType", "company");
        }, //
    




        zhankai() {
            let hasPower = true;
            if (!hasPower) {
                this.openMenu = [];
            }
            // this.formatCC();
        },




        // Company type 超出省略 显示
        onMouseOver(str, i) {
            const tag = this.$refs.str[i];
            const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
            const contentWidth = tag.offsetWidth; // 获取元素可视宽度
            this.isShowTooltip = contentWidth <= parentWidth;
        },
        //菜单checkbox选择
        menuCheck(val) {
            this.getConditions()
            let Obj={
                 companyName: this.cascInptComapny,
                companyIsicEn: this.cascInptIndustry,
                companyTypeEn: this.companyTypeCheckList[0],
                companyStatusEn: this.companyStatusCheckList[0],
                startTime: this.datePicker==null?'':this.datePicker[0],
                endTime:  this.datePicker==null?'':this.datePicker[1]
            }

    this.$emit('FilterMenuObj',Obj)

        },
        //获取左边菜单
        async getConditions() {
            this.Leftloadig = true;
            let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;

            const params = {
                userId: userinfo.id,
                portfolioId: '',
                companyName: this.cascInptComapny,
                companyIsicEn: this.cascInptIndustry,
                companyTypeEn: this.companyTypeCheckList[0],
                companyStatusEn: this.companyStatusCheckList[0],
                startTime: this.datePicker==null?'':this.datePicker[0],
                endTime:  this.datePicker==null?'':this.datePicker[1]
            };
            await getUserCompanyActionFilter(params).then((res) => {
                if (res && res.code) {
                    this.Leftloadig = false;
                    this.industryList = res.data.industryList;
                    this.industryPreList = res.data.industryList;

                    this.companyTypeList = res.data.companyTypeList;

                    // this.companyTypeList=
                    this.companySizeList = res.data.companySizeList;
                    this.companyStatusList = res.data.companyStatusList;

                } else {
                    this.Leftloadig = false;
                }
            });
        },
        //国家级联搜索不区分大小写

        // 过滤数据
        createFilter(queryString) {
            return (countryList) => {
                return (
                    countryList.label.toLowerCase().indexOf(queryString.toLowerCase()) ===
                    0
                );
            };
        },

        createFilterInd(queryString) {
            return (industryList) => {
                return (
                    industryList.name.toLowerCase().indexOf(queryString.toLowerCase()) >
                    -1
                );
            };
        },
        //清除所有标签
  
        // srcviewscompanylistcompanyvueMethodEnd
    },
};
</script>
<style scoped>
.uedbd2 {
    height: 100%;
}


.udb507two {
    width: 100% !important;
}

.left_menu {
    width: 27rem;
}

.u1QPawD {
    display: none;
}

.ufe717 {
    width: 12.214285714285714em;
    font-size: 1em;
    background-color: rgb(255, 255, 255);
}

.ukQ5lVZ {
    margin-left: 0.5em;
}

.u82ef5 {
    display: flex;
    padding-right: 0.5em;
    padding-top: 0.5em;
    padding-left: 0.5em;
    padding-bottom: 0.5em;
}

.u0a5ae {
    flex: auto;
    margin-left: 0.5em;
}

.u4bf20 {
    position: relative;
}

.u04a90 {
    display: flex;
    align-items: flex-start;
    height: 0;
    box-sizing: inherit;
    flex: auto;
    overflow-y: auto;
    margin-top: 0.5em;
}

.u1ec6b2 {
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    background-color: rgb(240, 240, 240);
}

.uff2cd {
    margin-left: 3.5714285714285716em;
}

.u5t26i8 .active {
    display: block;
}

.u5t26i8 path {
    display: none;
}

.u82ef5:hover .u0a5ae {
    color: rgb(33, 104, 235);
}

.u82ef5:hover .u5a792 {
    display: block;
}

.table_box /deep/ .el-table thead .company_link>.cell {
    padding-left: 2.857142857142857em !important;

}

.table_box /deep/ .el-table thead .cell {
    border-right: 2px solid #cccccc !important;
    ;
    min-height: 25px;

}

.table_box /deep/ .el-table thead .el-table-column--selection .cell {
    border-right: none !important;
}

.tree_table_box /deep/ .el-table thead .company_link>.cell {
    padding-left: 1.4285714285714286em !important;
}

.table_box /deep/ .el-table th.el-table__cell {

    height: 3.5714285714285716rem;
}

.table_box /deep/ .el-table td.el-table__cell {

    height: 4.285714285714286em;
}

.left_menu /deep/ .el-loading-mask {
    background-color: #f5f5f5 !important;
}

.left_menu {


    max-height: 98%;
    overflow-y: auto;
}

.hidemenu {
    display: block;
    width: 0em;
    padding-left: 0em;
    padding-top: 0em;
    padding-bottom: 0em;
    padding-right: 0em;
    box-sizing: border-box;
    overflow-y: hidden;
    overflow-x: hidden;
}

.collapsetitel {
    margin-left: 1.7857142857142858rem;
    font-family: 'DMSans Bold';
    position: relative;
    width: 100%;
}

.Clear_all {
    position: absolute;
    right: 0px;
    font-size: 16px;
    z-index: 999;
    cursor: pointer;
}

.table-index {
    /* display: none; */
}



@media screen and (max-width: 1441px) {
    .collapsetitel {
        font-size: 16px;
    }
}

/deep/ .el-range-editor.el-input__inner {
    padding: 0px !important;
}
/deep/ .el-collapse-item__wrap {
    overflow: visible !important;
}
/* .wrap {
  background: #f5f5f5;
  position: fixed;
  left: 0px;
  overflow-y: auto;

} */
</style>